<template >
  <template
      v-if="lang"
  >
    <ul class="nav nav-tabs mb-2">
      <li
          v-for="(langItem, langIndex)  in lang"
          class="nav-item"
      >
        <a
            :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
            @click.prevent="changeTab(langIndex)"
            href="#"
        >
          <country-flag
              :country='langItem.flag'
              size="small"
          />
          {{langItem.title}}

        </a>
      </li>
    </ul>
    <template
        v-for="(langItem, langIndex)  in lang"
    >
      <div
          v-show="activeTab == langIndex"
      >
        <html-editor3
            v-if="inputObj.params && inputObj.params.is_wysiwig"
            v-model="inputModel[langIndex]"
            editor-type="segment_odstavec"
            :editor-config="inputObj.params.editor"
            :langCode="langIndex"
        />
        <template v-else>
          <textarea
              v-model="inputModel[langIndex]"
              :id="inputObj.name + '_lang_' + langIndex"
              :ref="'textarea_' + langIndex"
              type="text"
              class="form-control"
              @focus="inputFormat(langIndex)"
              @focusout="inputFormat(langIndex)"
              @input="applyInputFormat(langIndex)"
              style="min-height: 250px;"
          >
          </textarea>
        </template>

        <div
            v-if="error"
            class="alert alert-danger mt-2"
        >
          <i class="bi bi-exclamation-triangle-fill me-2"/>
          <span>{{error}}</span>
        </div>

      </div>
    </template>
    <!--
    <display-debug>
      <template #debugView>
        inputObj {{inputModel}}
      </template>
    </display-debug>
-->
  </template>
</template>
<script>



import htmlEditor3 from "@/components/content/htmlEditor_v3";
import CountryFlag from "vue-country-flag-next"
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import prettier from 'prettier/standalone';
import parserHtml from 'prettier/plugins/html';
export default {
  name: "TextAreaLangSegment",
  components: {
    DisplayDebug,
    CountryFlag,
    htmlEditor3,
    prettier,
    parserHtml,
  },
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": [Object],
    "formObj": Object,
    "modelValue": [String, Object],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: null,
      activeTab: null,
      timerFormat: null,
      error: null,
    }
  },
  created() {
    if(this.lang) {
      this.inputModel = {}
      for (const i in this.lang){
        if(this.activeTab === null) {
          this.activeTab = i;
        }
        //console.log('dev TextAreaSegment created obsah', i, this.inputObj.obsah)
        if(
            this.inputObj.obsah
            && typeof this.inputObj.obsah[i] != 'undefined'
        ) {
          this.inputModel[i] = this.inputObj.obsah[i];
        }else{
          this.inputModel[i] = null
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    applyInputFormat(langIndex) {
      //console.log('[htmlEditor.onEditorWysiwygChange] inputModel', this.inputObj.slug)

      if(this.timerFormat) clearInterval(this.timerFormat);
      this.timerFormat = setTimeout(
          () => {
            this.inputFormat(langIndex)
          },
          1000
      )
    },
    async inputFormat(langIndex) {
      if(
          this.inputObj.slug == 'html'
      ){
        const elRef = this.$refs['textarea_' + langIndex][0];

        const startPos = elRef.selectionStart;
        const endPos = elRef.selectionEnd;
        //console.log("dev el ref",  startPos, endPos);

        try {
          // Prettier ve standalone verzi vrací Promise
          this.inputModel[langIndex]  = await prettier.format(this.inputModel[langIndex] , {
            parser: 'html',
            plugins: [parserHtml],
            tabWidth: 4,
            printWidth: 128
          });

          this.error = null;
          this.$nextTick(() => {
            //elRef.focus();
            // Nastavíme kurzor na novou pozici
            // Prettier mohl přidat mezery před, takže ideální je posunout ho na 'newCursorPos'
            elRef.setSelectionRange(startPos, endPos);
          });

        } catch (error) {
          this.error = error;
          console.error("Chyba při formátování HTML:", error);
        }
      }
    },
    changeTab(index) {
      this.activeTab = index;
    }
  },
  watch: {
    activeLang: {
      handler() {
        this.activeTab = this.activeLang;
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        //console.log('dev WATCH TextAreaSegment inputModel',newVal, oldVal);
        if(typeof oldVal != 'undefined'){
          this.$emit('update:modelValue', newVal )
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>